import { DxFlow } from './dxflow';
import { Param } from './param';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { DxFlow_Fwd_Lnk } from './dxflow_fwd_lnk';
import { CommonEnums } from 'src/app/shared/common.enums';
import { TNode } from './tnode';
import { ParamsUtil } from '../utils/params.util';
import { DxFlow_Fwd_LnksUtil } from '../../utils/dxflow_fwd_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from '../../utils/dxflow_obj_properties.util';
import { ArrayUtil } from '../utils/array.util';
import { TNodesUtil } from '../utils/tnodes.util';
import { JobsUtil } from 'src/app/modules/stream/jobs/jobs.util';
import { CanvasComment } from './canvas-comment';
import { CanvasCommentUtil } from '../../utils/canvascomment.util';

export class Stream {
    fldr_Id: number;
    dxFlow: DxFlow;
    params: Array<Param>;
    sqlParams: Array<Param>;
    projectParams: Array<Param>;
    objects: Array<any>
    dxFlow_Fwd_Lnks: Array<DxFlow_Fwd_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    comments : Array<CanvasComment>;
    lockBy: string;
    mode_Ind: string;
    change_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string
    ref_Id: number;
    ref_Cd: string;
    dependent_Ids: Array<number>;
    fldrNm: string;
    isDependent: boolean;
    imageUrl: string;
    recExists: boolean;
    selectedFlag: string;
    fldr_Cd: string;
    layerNm: string;
    admin_LogLevel: string;
    transformCoordinates: Array<TNode>;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.dxFlow = new DxFlow();
        this.params = new Array<Param>();
        this.sqlParams = new Array<Param>();
        this.projectParams = new Array<Param>();
        this.objects = new Array<any>();
        this.dxFlow_Fwd_Lnks = new Array<DxFlow_Fwd_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.comments  = new Array<CanvasComment>();
        this.dependent_Ids = new Array<number>();
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.change_Ind = CommonEnums.defaults.CHANGE_IND_NO;
        this.unlock_Ind = CommonEnums.defaults.UNLOCK_IND_UNSET;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.isDependent = false;
        this.imageUrl = "svg-icons/jobflow/stream.svg";
        this.recExists = false;
        this.selectedFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.layerNm = CommonEnums.defaults.STRING_EMPTY;
        this.admin_LogLevel = CommonEnums.defaults.STRING_EMPTY;
        this.transformCoordinates = new Array<TNode>();
    }

    static parse(streamTmp: Stream): Stream {
        let stream: Stream = new Stream();
        stream.copyFrom(streamTmp);
        return stream;
    }

    copy(): Stream {
        let streamTmp: Stream = new Stream();

        streamTmp.fldr_Id = this.fldr_Id;
        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();
        streamTmp.params = paramsUtil.copy(this.params);
        streamTmp.sqlParams = paramsUtil.copy(this.sqlParams);
        streamTmp.projectParams = paramsUtil.copy(this.projectParams);

        streamTmp.comments = CanvasCommentUtil.getInstance().copy(this.comments);
        streamTmp.objects = JobsUtil.getInstance().copy(this.objects);
        streamTmp.dxFlow_Fwd_Lnks = DxFlow_Fwd_LnksUtil.getInstance().copy(this.dxFlow_Fwd_Lnks);
        streamTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        streamTmp.dependent_Ids = ArrayUtil.getInstance().copy(this.dependent_Ids);

        streamTmp.lockBy = this.lockBy;
        streamTmp.mode_Ind = this.mode_Ind;
        streamTmp.change_Ind = this.change_Ind
        streamTmp.unlock_Ind = this.unlock_Ind;
        streamTmp.error_Cd = this.error_Cd;
        streamTmp.error_Msg = this.error_Msg;
        streamTmp.ref_Cd = this.ref_Cd
        streamTmp.fldrNm = this.fldrNm;
        streamTmp.ref_Id = this.ref_Id;
        streamTmp.isDependent = this.isDependent;
        streamTmp.imageUrl = this.imageUrl;
        streamTmp.recExists = this.recExists;
        streamTmp.selectedFlag = this.selectedFlag;
        streamTmp.fldr_Cd = this.fldr_Cd;
        streamTmp.layerNm = this.layerNm;
        streamTmp.admin_LogLevel = this.admin_LogLevel;

        streamTmp.transformCoordinates = TNodesUtil.getInstance().copy(this.transformCoordinates);

        return streamTmp;
    }

    copyFrom(streamTmp: Stream): void {
        this.dxFlow.copyFrom(streamTmp.dxFlow);
        
        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();
        paramsUtil.copyFrom(this.params, streamTmp.params);
        paramsUtil.copyFrom(this.sqlParams, streamTmp.sqlParams);
        paramsUtil.copyFrom(this.projectParams, streamTmp.projectParams);
        CanvasCommentUtil.getInstance().copyFrom(this.comments, streamTmp.comments);
        
        JobsUtil.getInstance().copyFrom(this.objects, streamTmp.objects);
        DxFlow_Fwd_LnksUtil.getInstance().copyFrom(this.dxFlow_Fwd_Lnks, streamTmp.dxFlow_Fwd_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, streamTmp.dxFlow_Obj_Properties);
        ArrayUtil.getInstance().copyFrom(this.dependent_Ids, streamTmp.dependent_Ids);
        TNodesUtil.getInstance().copyFrom(this.transformCoordinates, streamTmp.transformCoordinates);

        this.fldr_Id = streamTmp.fldr_Id;
        this.lockBy = streamTmp.lockBy;
        this.mode_Ind = streamTmp.mode_Ind;
        this.change_Ind = streamTmp.change_Ind
        this.unlock_Ind = streamTmp.unlock_Ind;
        this.error_Cd = streamTmp.error_Cd;
        this.error_Msg = streamTmp.error_Msg;
        this.ref_Cd = streamTmp.ref_Cd
        this.fldrNm = streamTmp.fldrNm;
        this.ref_Id = streamTmp.ref_Id;
        this.isDependent = streamTmp.isDependent;
        this.imageUrl = streamTmp.imageUrl;
        this.recExists = streamTmp.recExists;
        this.selectedFlag = streamTmp.selectedFlag;
        this.fldr_Cd = streamTmp.fldr_Cd;
        this.layerNm = streamTmp.layerNm;
        this.admin_LogLevel = streamTmp.admin_LogLevel;
    }

    compare(streamTmp: Stream): string {
        let diffString: string = this.dxFlow.compare(streamTmp.dxFlow);
        if (diffString != '') return diffString;

        for (let i: number = 0; i < this.objects.length; i++) {
            if (this.objects[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                return 'Job has modified.'
            }
        }

        for (let i: number = 0; i < this.comments.length; i++) {
            if (this.comments[i].change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                return 'Comment has modified.'
            }
        }

        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();

        diffString = paramsUtil.compare(this.params, streamTmp.params);
        if (diffString != '') return diffString;

        diffString = paramsUtil.compare(this.sqlParams, streamTmp.sqlParams);
        if (diffString != '') return diffString;

        diffString = paramsUtil.compare(this.projectParams, streamTmp.projectParams);
        if (diffString != '') return diffString;

        diffString = DxFlow_Fwd_LnksUtil.getInstance().compare(this.dxFlow_Fwd_Lnks, streamTmp.dxFlow_Fwd_Lnks);
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, streamTmp.dxFlow_Obj_Properties);
        if (diffString != '') return diffString;

        return '';
    }

    toString(): string {
        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();
        return "Stream [fldr_Id =" + this.fldr_Id +
            ", dxFlow =" + this.dxFlow.toString() +
            ", params =" + paramsUtil.toString(this.params) +
            ", sqlParams =" + paramsUtil.toString(this.sqlParams) +
            ", projectParams =" + paramsUtil.toString(this.projectParams) +
            ", objects =" + JobsUtil.getInstance().toString(this.objects) +
            ", dxFlow_Fwd_Lnks =" + DxFlow_Fwd_LnksUtil.getInstance().toString(this.dxFlow_Fwd_Lnks) +
            ", dxFlow_Obj_Properties =" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", lockBy = " + this.lockBy +
            ", mode_Ind=" + this.mode_Ind +
            ", change_Ind=" + this.change_Ind +
            ", unlock_Ind=" + this.unlock_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", dependent_Ids" + ArrayUtil.getInstance().toString(this.dependent_Ids) +
            ", fldrNm" + this.fldrNm +
            ", isDependent=" + this.isDependent +
            ", imageUrl" + this.imageUrl +
            ", isRecExists+" + this.recExists +
            ", selectedFlag" + this.selectedFlag +
            ", fldr_Cd" + this.fldr_Cd +
            ", layerNm" + this.layerNm +
            ", admin_LogLevel" + this.admin_LogLevel +
            ", transformCoordinates" + TNodesUtil.getInstance().toString(this.transformCoordinates) + "]";
    }
}